import './page.scss'
import {useNavigate, useSearchParams} from "react-router-dom";
import {ReactNode, useCallback, useState} from "react";
import {InputOTP} from "@/components/ui/input-otp.tsx";
import {CommonService} from '@/services';
import {LOGIN_ROUTE} from '@/constants/RoutesConfig';
import {Button} from "@/components/ui/button.tsx";
import {buttonVariants} from "@/constants/animations.ts";
import {BackIcon} from "@/constants/ImageConfig.ts";
import {motion} from "framer-motion";


const OtpScreen = () => {

    // const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    // Fix URL decoding issue where + gets decoded as space
    const rawEmail = searchParams.get('email') || '';
    const email = rawEmail.replace(/ /g, '+');
    const [resendLoading, setResendLoading] = useState<boolean>(false);
    const [isVerifying, setIsVerifying] = useState(false);



    const resendOtp = useCallback(() => {
        setResendLoading(true);
        
        // Track OTP resend attempt
        CommonService.handleMixpanelTrack("OTP Resend Attempt", {
            email: email,
            timestamp: new Date().toISOString()
        });
        
        CommonService._account.sendOtpEmail({ email })
            .then(() => {
                // Track successful OTP resend
                CommonService.handleMixpanelTrack("OTP Resend Success", {
                    email: email,
                    timestamp: new Date().toISOString()
                });
                CommonService._alert.showToast("OTP resent successfully", "success");
            })
            .catch(() => {
                // Track failed OTP resend
                CommonService.handleMixpanelTrack("OTP Resend Failed", {
                    email: email,
                    timestamp: new Date().toISOString()
                });
                CommonService._alert.showToast("Failed to resend OTP", "error");
            })
            .finally(() => {
                setResendLoading(false);
            });
    }, [email]);

    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleOtpChange = () => {
        setHasError(false);
        setErrorMessage("");
    };

    const handleOtpComplete = useCallback((value: string) => {
        const payload = {
            otp: value,
            email: email
        };

        setIsVerifying(true);
        
        CommonService._account.verifyOtp(payload)
            .then(() => {
                // Track successful OTP verification
                CommonService.handleMixpanelTrack("OTP Verification Success", {
                    email: email,
                    timestamp: new Date().toISOString()
                });
                CommonService._alert.showToast("OTP verified successfully", "success");
                navigate(LOGIN_ROUTE);
            })
            .catch((error: any) => {
                // Track failed OTP verification
                CommonService.handleMixpanelTrack("OTP Verification Failed", {
                    email: email,
                    error: error?.detail?.error || "Unknown error",
                    timestamp: new Date().toISOString()
                });
                setHasError(true);
                setErrorMessage("Please double-check your OTP and try again.");
                CommonService._alert.showToast(error?.detail?.error || "Otp verification failed", "error");
            })
            .finally(() => {
                setIsVerifying(false);
            });
    }, [email, navigate]);

    return (
        <div className={'auth-background '}>
            <div className={'auth-screen-title-wrapper'}>
                <div className={'auth-screen-title'}>
                    Verify it's really you
                </div>
                <div className={'auth-screen-subtitle  text-secondary-foreground mt-4'}>
                    Enter the OTP sent to {email} to complete.
                </div>
            </div>
            <div className={'mt-5'}>
                <InputOTP
                    maxLength={6}
                    onChange={handleOtpChange}
                    onComplete={handleOtpComplete}
                    hasError={hasError}
                    errorMessage={errorMessage}
                    loading={isVerifying}
                />
                 <motion.div variants={buttonVariants} whileHover="hover">
                        <Button
                            type="button"
                            variant="text"
                            onClick={() => {
                                
                                resendOtp();
                            }}
                            loading={resendLoading}
                            className="text-sm"
                        >
                            Resend OTP
                        </Button>
                    </motion.div>
                {hasError && <>
                   
                    <motion.div variants={buttonVariants} whileHover="hover">
                        <Button
                            fullWidth
                            type={"button"}
                            variant={"link"}
                            onClick={() => {
                                // Track back to sign in button click
                                CommonService.handleMixpanelTrack("Back to Sign In Button Clicked", {
                                    email: email,
                                    timestamp: new Date().toISOString()
                                });
                                navigate(LOGIN_ROUTE);
                            }}
                            prefixIcon={<BackIcon/> as ReactNode}
                        >
                            Back to Sign In
                        </Button>
                    </motion.div>
                </>}

            </div>
        </div>
    )
}

export default OtpScreen
